<template>
  <div class="text-center mb-10">
    <h1 class="mb-4">
      {{ header.title }}
    </h1>
    <p class="text-body-2">
      {{ header.description }}
    </p>
    <div class="mt-10 pt-0">
      <img
        data-src="@images/public/how-it-work/header.png"
        class="lazyload mx-auto w-full lg:w-auto"
        :alt="header.title"
      >
    </div>
  </div>
</template>
<script>
import staticData from './static-data'

export default {
  name: 'Header',
  data () {
    return {
      header: staticData.component.Header
    }
  }
}
</script>
